import * as React from "react";

import { Levels } from "../../../../Levels/Levels";
import { TemperatureLevels } from "../../../../../../rest/GroupAction";
import { Unit } from "../../../../../../rest/Misc";
import { ActionType } from "../flux";
import { Polyglot } from "../../../../../../polyglot";

interface Props
{
    polyglot: Polyglot;
    levels: TemperatureLevels;
    unit: Unit;
    axleCount: number;
    setAxle: (axle: number) => void;
    setRedMax: (value: number) => void;
    setYellowMax: (value: number) => void;
    setYellowMin: (value: number) => void;
    setRedMin: (value: number) => void;
}

export class TemperatureGroupAction extends React.Component<Props, any>
{
    static defaultProps = {
        type: ActionType.SetTemperature
    };
    
    render()
    {
        const { polyglot, unit, levels, setRedMax, setYellowMax, setYellowMin, setRedMin } = this.props;
        const { Axle, AbsLevelMaximumRed, AbsLevelMaximumYellow, AbsLevelMinimumYellow, AbsLevelMinimumRed } = levels;
        
        return (
            <Levels polyglot={polyglot}
                unitName={unit ? unit.Name : ''}
                axleCount={this.props.axleCount} axle={Axle} setAxle={this.props.setAxle}
                redMax={AbsLevelMaximumRed} setRedMax={setRedMax}
                yellowMax={AbsLevelMaximumYellow} setYellowMax={setYellowMax}
                yellowMin={AbsLevelMinimumYellow} setYellowMin={setYellowMin}
                redMin={AbsLevelMinimumRed} setRedMin={setRedMin}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/BatchEdit/GroupActions/TemperatureGroupAction.tsx